module.exports = __webpack_public_path__ + "static/media/discord.d2748cef.svg";